// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._16,
    paddingTop: theme.other.spacing._16,
    paddingBottom: theme.other.spacing._24,
    paddingLeft: theme.other.spacing._24,
    paddingRight: theme.other.spacing._24,
    backgroundColor: theme.white,
    borderRadius: theme.radius.lg,
    width: 420,
    [theme.fn.smallerThan('md')]: {
      width: '100%',
    },
  },

  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.other.spacing._16,
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  radioGroup: {
    '& .mantine-Group-root': {
      display: 'flex',
      alignItems: 'center',
      gap: theme.other.spacing._16,
      paddingTop: theme.other.spacing._24,
      paddingBottom: theme.other.spacing._24,
      paddingLeft: 0,
      paddingRight: theme.other.spacing._16,
    },
  },

  radioItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.other.spacing._16,
    paddingLeft: 0,
    paddingRight: theme.other.spacing._16,
    paddingTop: theme.other.spacing._4,
    paddingBottom: theme.other.spacing._16,
    borderBottom: `1px solid ${theme.colors.gray2[0]}`,
    cursor: 'pointer',
    minHeight: 72,
    width: '100%',
  },

  radio: {
    '&:checked': {
      backgroundColor: theme.white,
      color: theme.colors.blue[9],
      borderColor: theme.colors.blue[9],
    },
  },

  radioIcon: {
    color: theme.colors.blue[9],
    transform: 'scale(1.75)!important',
  },

  radioLabel: {
    flex: 1,
    cursor: 'pointer',
  },

  buttons: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._16,
    width: '100%',
  },

  textareaContainer: {
    width: '100%',
    marginTop: -theme.other.spacing._24,
    paddingRight: theme.other.spacing._16,
  },

  textarea: {
    backgroundColor: theme.colors.gray2[0],
    borderRadius: theme.other.spacing._8,
    padding: theme.other.spacing._16,
    minHeight: 100,
    border: 'none',

    '& .mantine-Textarea-input': {
      backgroundColor: 'transparent',
      border: 'none',
      padding: 0,
      minHeight: 100,
      resize: 'none',

      '&::placeholder': {
        color: theme.colors.gray2[3],
      },
    },
  },
}));
